interface ConversionBadgeProps {
  isConverted: boolean
}

export function ConversionBadge({ isConverted }: ConversionBadgeProps) {
  if (!isConverted) {
    return <span className="text-gray-300">-</span>
  }

  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700">
      <svg className="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
      Converted
    </span>
  )
}
